import { ApplicantProfileSchema } from "@nimble/datamodel/schemas/applicantProfile";
import { ApplicantBackgroundCreateSchema } from "@nimble/datamodel/schemas/application";
import { z } from "zod";

const submitted = ApplicantBackgroundCreateSchema.shape;
const experienceEntry = submitted.experience.unwrap().unwrap().element;
const educationEntry = submitted.education.unwrap().unwrap().element;

const resumeEducationEntry = educationEntry.safeExtend({
  schoolId: z.null(),
  schoolCustom: educationEntry.shape.schoolCustom.unwrap().unwrap(),
});

export const ResumeSchema = z.object({
  applicant: ApplicantProfileSchema.pick({
    firstName: true,
    middleName: true,
    lastName: true,
    phone: true,
    address: true,
  }),
  experience: z.array(
    experienceEntry.extend({
      startDate: experienceEntry.shape.startDate.nullable(),
    }),
  ),
  education: z.array(resumeEducationEntry),
  certificates: submitted.certificates.unwrap().unwrap(),
  languages: z.array(submitted.languages.unwrap().unwrap().element),
  references: z.array(submitted.references.unwrap().unwrap().element),
  exams: z.array(submitted.exams.unwrap().unwrap().element),
});
export type ParsedResume = z.infer<typeof ResumeSchema>;

export const MAX_RESUME_TEXT_LENGTH = 150_000;

export const resumeTextSchema = z
  .string()
  .min(1)
  .max(MAX_RESUME_TEXT_LENGTH)
  .brand<"ResumeText">();
export type ResumeText = z.infer<typeof resumeTextSchema>;

export function mintResumeText(text: string): ResumeText {
  const unbranded: Omit<ResumeText, typeof z.$brand> = text;
  return unbranded as ResumeText;
}

export const resumeParsingRequestSchema = z.object({
  text: resumeTextSchema,
});

export const resumeParsingResponseSchema = z.object({
  success: z.literal(true),
  data: ResumeSchema,
  meta: z.object({
    timestamp: z.iso.datetime(),
  }),
});
